<template>
  <Modal
    width="920"
    :title="title"
    v-model="state"
    class-name="vertical-center-modal"
    :closable="btnRetry"
    :mask-closable="false">
    <Spin size="large" fix v-if="show"></Spin>
    <result
      :title="head"
      :columns="columns"
      :data="data"></result>
    <div slot="footer" class="c-resulter-footer">
      <Button type="default" @click="$emit('on-retry')" v-if="btnRetry">重试</Button>
      <Button type="default" @click="close">完成并关闭</Button>
      <Button type="primary" @click="$emit('on-next')" v-if="btnSuccess && next">下一步</Button>
    </div>
  </Modal>
</template>
<script>
import Result from './result.vue'
export default {
  name: 'resulter',
  components: { Result },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    head: {
      type: String
    },
    show: {
      type: Boolean
    },
    columns: {
      type: Array
    },
    data: {
      type: Array
    },
    next: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  computed: {
    state: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    btnSuccess () {
      return this.data.some(ret => ret.media_name ? !ret.status : ret.ad_id)
    },
    btnRetry () {
      return this.data.some(ret => ret.media_name ? ret.status : ret.ad_id === null)
    }
  },
  methods: {
    close () {
      this.$Message.info({
        content: '页面将 2 秒后自动关闭',
        duration: 2,
        onClose: () => {
          window.close()
        }
      })
    }
  }
}
</script>
